<template>
  <div>
  <section v-if="profiles">
    <div class="status"><h2 v-translate>Odběratelské profily</h2>
      <a
          v-if="isEditable"
          @click.stop.prevent="_createNewProfile"
          :title="$gettext('Odběratelské profily')"
          class="add add_expand"
          v-translate>Přidat profil odběratele</a>
    </div>
    <div class="table_overflow">
      <table class="vypis">
      <thead>
      <tr v-if="profiles.length > 0">
        <th class="no_padding drag_drop"></th>
        <th class="no_padding checkbox"></th>
        <th><span class="name"><strong v-translate>Název</strong></span></th>
        <th style="min-width: 100px"><span class="name" v-translate>Profilový obrázek</span></th>
        <th><span v-translate>Dětský profil</span></th>
        <th><span v-translate>Věkový limit</span></th>
        <th><span v-translate>Přístup s PINem</span></th>
        <th><span v-translate>Editace s PINem</span></th>
        <th><span v-translate>Naposledy použito</span></th>
        <th><span v-translate>Poslední zařízení</span></th>
        <th><span v-translate>Vytvořeno</span></th>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <tbody>
      <ProfileRow v-for="profile in profiles"
              :profile="profile"
              :id-subscriber="idSubscriber"
              :key="profile.id"
              ref="profile_row"
              :selectedEntities="selectedEntities"
              :isDeletable="isEditable && !lastProfile"
              @input="select"
              @deleteProfile="onDeleteProfile" />
      <tr v-if="profiles.length === 0">
        <td colspan="5" v-translate>Nebyly nalezeny žádné profily.</td>
      </tr>
      </tbody>
    </table>
    </div>
    <local-list-action-line
        :entities="profiles"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        @select-all="toggleSelectAll"
        @run-multiple-action="executeMultipleAction"
    ></local-list-action-line>
  </section>
  </div>
</template>

<script>
import ProfileRow from "./ProfileRow";
import localTable from "@/components/mixins/local-table"

export default {
  name: "Profiles",
  components: {ProfileRow},
  mixins: [localTable],
  props: {
    idSubscriber: Number,
    profiles: Array,
    isEditable: Boolean,
  },
  data(){
    return {
      tabName: "profiles",
    }
  },
  methods: {
    onDeleteProfile(id) {
      this.$emit('deleteProfile', id)
    },
    _createNewProfile(){
      this.$router.push({
        name: 'subscriberProfileNew',
        params: {
          idSubscriber: this.idSubscriber
        }
      });
    },
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeleteProfile(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    }
  },
  computed: {
    entities(){
      return this.profiles;
    },
    lastProfile(){
      return this.profiles.length <= 1;
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    csvHeaders(){
      return {
        'name': {name: this.$gettext('Název')},
        'is_child': {name: this.$gettext('Dětský profil'), callback: (entity) => { return entity.is_child ? 'ANO' : 'NE'}},
        'age_limit': {name: this.$gettext('Věkový limit') },
        'access_with_pin': {name: this.$gettext('Přístup s PINem'), callback: (entity) => {return entity.security.access_with_pin ? 'ANO': 'NE' }},
        'edit_with_pin': {name: this.$gettext('Editace s PINem'), callback: (entity) => {return entity.security.edit_with_pin ? 'ANO': 'NE' }},
        'timestamp_created': {name: this.$gettext('Vytvořeno'), callback: (entity) => {return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''}},
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/profiles/Profiles.vue